import { addAccumulationOfStatusesCard } from "./cards/accumulation-of-statuses";
import { addAverageProjectMaturityCard } from "./cards/average-project-maturity";
import { addCompletedCumulativeItemsOverTimeCard } from "./cards/completed-cumulative-items-over-time";
import { addCompletedCumulativeProjectsLineChartCard } from "./cards/completed-cumulative-projects-line-chart";
import { addCompletedItemsOverTimeCard } from "./cards/completed-items-over-time";
import { addCompletedItemsPerCategoryCard } from "./cards/completed-items-per-category";
import { addCompletedItemsPerCategoryLevelCard } from "./cards/completed-items-per-category-level";
import { addCompletedProjectsCategoryCard } from "./cards/completed-projects-category";
import { addCompletedProjectsLineChartCard } from "./cards/completed-projects-line-chart";
import { addCompletionByMaturityCards } from "./cards/completion-by-maturity";
import { addCompletionOfProjectsCard } from "./cards/completion-of-projects";
import { addCompletionOfTrackingItemsCard } from "./cards/completion-of-tracking-items";
import { addCompletionPerMaturityLineCard } from "./cards/completion-per-maturity-line";
import { addCountCompletionOfItemsCard } from "./cards/count-completion-of-items";
import { addCountCompletionOfProjectsCard } from "./cards/count-completion-of-projects";
import { addCountofItemsStatusCard } from "./cards/countof-items-status";
import { addCountofProjectStatusCard } from "./cards/countof-project-status";
import { addDurationCard } from "./cards/duration";
import { addManagementSummaryCard } from "./cards/management-summary";
import { addMaturityOfItemsCard } from "./cards/maturity-of-items";
import { addNumberOfCompletedProjectsCard } from "./cards/number-of-completed-projects";
import { addNumberOfCompletedTrackingItemsCard } from "./cards/number-of-completed-tracking-items";
import { addNumberOfItemsDueCard } from "./cards/number-of-items-due";
import { addNumberOfProjectsCard } from "./cards/number-of-projects";
import { addNumberOfProjectsDueCard } from "./cards/number-of-projects-due";
import { addNumberOfTrackingItemsCard } from "./cards/number-of-tracking-items";
import { addOeMaturityLevelCard } from "./cards/oe-maturity-level";
import { addOverallCompletionCard } from "./cards/overall-completion";
import { addPercentageOfBudgetSpentCard } from "./cards/percentage-of-budget-spent";
import { addProgramDescriptionCard } from "./cards/program-description";
import { addProgressCard } from "./cards/progress";
import { addRatioOfCompletedItemsCard } from "./cards/ratio-of-completed-items";
import { addRatioOfCompletedProjectsCard } from "./cards/ratio-of-completed-projects";
import { addSemaphoreStatusOfItemsDonutChartCard } from "./cards/semaphore-status-of-items-donut-chart";
import { addStatusCard } from "./cards/status";
import { addStatusOfItemsCard } from "./cards/status-of-items";
import { addStatusOfProjectsDonutChartCard } from "./cards/status-of-projects-donut-chart";
import { addTeamCard } from "./cards/team";
import { addTitleCard } from "./cards/title";
import { DashboardCardContext } from "./context";

/**
 * Every card the dashboard is made of, **in the order they are added**.
 *
 * The order is the point of this array: the drag-and-drop layout places cards
 * by the sequence in which they reach the view, and `dashboardComponentValues`
 * is keyed by the component ids they register. Keeping it here as data rather
 * than as a run of 32 calls inside the plugin is what lets a spec assert it
 * (#2222) — and what stops an import sorter from silently reordering the page.
 *
 * Each card takes the shared `DashboardCardContext` instead of reading `this`,
 * because they all need the same derived names (`itemName`, `getCardCopy`, …)
 * that used to sit as locals at the top of `buildDashboardView()`.
 */
export const DASHBOARD_CARDS: ((ctx: DashboardCardContext) => void)[] = [
  addTitleCard,
  addProgramDescriptionCard,
  addStatusCard,
  addOverallCompletionCard,
  addAccumulationOfStatusesCard,
  addNumberOfTrackingItemsCard,
  addNumberOfCompletedTrackingItemsCard,
  addNumberOfProjectsCard,
  addNumberOfCompletedProjectsCard,
  addNumberOfItemsDueCard,
  addNumberOfProjectsDueCard,
  addManagementSummaryCard,
  addTeamCard,
  addDurationCard,
  addProgressCard,
  addPercentageOfBudgetSpentCard,
  addStatusOfProjectsDonutChartCard,
  addCountofProjectStatusCard,
  addCountofItemsStatusCard,
  addCountCompletionOfProjectsCard,
  addRatioOfCompletedProjectsCard,
  addRatioOfCompletedItemsCard,
  addCountCompletionOfItemsCard,
  addSemaphoreStatusOfItemsDonutChartCard,
  addStatusOfItemsCard,
  addCompletionOfTrackingItemsCard,
  addCompletionOfProjectsCard,
  addCompletedProjectsCategoryCard,
  addCompletedItemsPerCategoryCard,
  addCompletedItemsPerCategoryLevelCard,
  addCompletedItemsOverTimeCard,
  addCompletedCumulativeItemsOverTimeCard,
  addCompletedProjectsLineChartCard,
  addCompletedCumulativeProjectsLineChartCard,
  addOeMaturityLevelCard,
  addAverageProjectMaturityCard,
  addMaturityOfItemsCard,
  addCompletionByMaturityCards,
  addCompletionPerMaturityLineCard,
];
